//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number,
      default: 0
    },
    itemH: {
      type: String,
      default: '2.8rem'
    },
    scrollNum: { // 超出多少滚动
      type: Number,
      default: 2
    },
    indexChange: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tabIndex: 0,
      itemKey: new Date().getTime()
    }
  },
  created() {
    this.tabIndex = this.index
  },
  methods: {
    switchTabItem(v) {
      if(this.indexChange) this.tabIndex = v
      this.$emit('update', { tabIndex: v, fn: this.changeIndex }) // fn 回调修改tabindex
    },

    changeIndex(v) { // 回调修改tabindex
      this.tabIndex = v
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/g-tab/index.vue